import React from "react";
import styled from "styled-components";
import { IonDatetime } from "@ionic/react";

const DatetimeContainer = styled.div``;
const ErrorContainer = styled.div`
  padding: 8px 4px 8px 4px;
  width: 100%;
`;
const ErrorMessage = styled.div`
  color: #eb445a;
`;

let FormDatetimeInput = (props) => {
  const { value, onChange } = props.input;

  const errorContainer = (
    <ErrorContainer>
      <ErrorMessage>{props.meta && props.meta.error}</ErrorMessage>
    </ErrorContainer>
  );

  return (
    <DatetimeContainer>
      <IonDatetime onIonChange={onChange} {...props} value={value} />
      {props.meta &&
        props.meta.error &&
        props.meta.submitFailed &&
        errorContainer}
    </DatetimeContainer>
  );
};

export default FormDatetimeInput;
